import React, { Component } from "react";

import ComponentHOC from "../hoc/ComponentHOC";
import Img from "react-image";
//Components imports
import InternalBanner from "./internal-banner";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { httpService } from "../actions/httpService";
//Images imports
import locationIcon from "../img/icons/location-icon.png";
import mailIcon from "../img/icons/mail.png";

class ContactComponent extends Component {
  sendMail() {
    const form = this.Form;
    var data = {
      nome: form.nome.value,
      email: form.email.value,
      tel: form.tel.value,
      mensagem: form.mensagem.value,
      assunto: form.assunto.value,
    };
    httpService.sendMail(data).then((res) => {});
  }
  render() {
    const { contact, banner, form } = this.props;
    return (
      <section className="contact-section">
        <div className="container banner-container">
          {/* <InternalBanner banner={banner}/> */}
          <div className="row justify-content-center align-items-center main-contact">
            <div className="col-12 col-lg-6">
              <div className="row justify-content-center align-items-center contact-info">
                <div className="col-12 col-lg-6 d-flex justify-content-start align-items-start contact-data">
                  <Img src={locationIcon} aria-hidden="true" />
                  <div>
                    <p>{contact.location}</p>
                    <p>{contact.location_cep}</p>
                  </div>
                </div>
                <div className="col-12 col-lg-6 d-flex justify-content-center align-items-end contact-data flex-column">
                  <div className="h-100 unpadded d-flex flex-row align-items-center">
                    <Img src={mailIcon} aria-hidden="true" />
                    <p>{contact.email}</p>
                  </div>
                </div>
              </div>
              <div className="row d-flex flex-column justify-content-center align-items-center contact-info">
                <form
                  ref={(c) => {
                    this.Form = c;
                  }}
                  onSubmit={this.sendMail.bind(this)}
                  className="contact-form"
                >
                  <input
                    type="text"
                    name="nome"
                    className="input-form w-100"
                    placeholder={form.name}
                  />
                  <input
                    type="email"
                    name="email"
                    className="input-form w-100"
                    placeholder={form.email}
                  />
                  <input
                    type="tel"
                    name="tel"
                    className="input-form w-100"
                    placeholder={form.phone}
                  />
                  <textarea
                    name="mensagem"
                    className="input-form w-100"
                    id=""
                    cols="30"
                    rows="2"
                    placeholder={form.message}
                  ></textarea>
                  <input type="submit" value={form.send} />
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ContactComponent.propType = {
  banner: PropTypes.array.isRequired,
  contact: PropTypes.array.isRequired,
  form: PropTypes.array.isRequired,
};

export default connect((state) => state)(ComponentHOC(ContactComponent));



// WEBPACK FOOTER //
// ./src/components/contact.js